import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// audit ST-16: a client-side route change never reset scroll position, so a student who scrolled
// down on one screen (e.g. picking a topic near the bottom of the Custom Build picker on a narrow
// phone) landed on the NEXT screen already scrolled past its own header/first question — looking
// exactly like a broken/blank mobile layout even though nothing actually overflows or is undersized.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
